var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"breakdown-list"}},[_c('card',{attrs:{"icon":"band-aid","headline":_vm.$t('breakdowns.breakdownList.infoboxHeadline'),"description":_vm.$t('breakdowns.breakdownList.infoboxDescription')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }